import { styled, Typography, Box } from '@mui/material';
import OopsCoin from 'assets/icons/OopsCoin';

export const StyledBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 16px;
`;

export const Illustration = styled(OopsCoin)`
  margin-bottom: 40px;
  max-width: 200px;
  min-height: 250px;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    max-width: 250px;
  }
`;

export const Title = styled(Typography)`
  margin-bottom: 40px;
`;

export const SubTitle = styled(Typography)`
  margin-bottom: 12px;
  text-align: center;
`;

export const BodyText = styled(Typography)`
  margin-bottom: 40px;
  text-align: center;
`;
